
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import { RouteName } from '@/router/routes';
import { Alerte } from '@/model/alerte';

export default Vue.extend({
  name: 'FicheAlerte',
  data: () => ({
    loading: true as boolean
  }),
  computed: {
    ...mapGetters({
      infoTiers: 'tiers/infoTiers',
      alertes: 'alertes/alertesUtilisateur',
      user: 'user/user'
    }
    ),
    username (): string | undefined {
      return this.user?.username;
    }
  },
  created () {
    this.loadAlertes(this.username)
      .then(() => {
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions({
      loadAlertes: 'alertes/loadAlertesUtilisateur'
    }),
    nbAlertesActives () :number {
      if (this.alertes) {
        return this.alertes
          .filter((a:Alerte) => a.actif === true)
          .length;
      } else {
        return 0;
      }
    },
    newAlerte () {
      this.$router.push({
        name: RouteName.MAIN_ALERTES_EDIT,
        params: {
          idAlerte: 'new'
        }
      });
    },
    gotoAlerte () {
      this.$router.push({
        name: RouteName.MAIN_ALERTES_LISTE,
        params: {
          idAlerte: 'new'
        }
      });
    }
  }
});
